import React from 'react';
import omit from 'lodash-es/omit';

import { Grid } from '@hbf/dsl';
import { useIntl } from 'ha/i18n';
import { FacilitiesGroupsTranslations } from 'ha/models/ListingFacilities/translations';
import { CharityListingFacilitiesToOmit } from 'ha/models/ListingFacilities/constants';
import { ListingFacilities } from '@ha/api/v2/types/Listing';

import { PreparedFacilities } from '../../utils/getFacilitiesByGroup';
import { ListingFacilitiesGroup } from './ListingFacilitiesGroup';

interface Props {
  facilities: PreparedFacilities[];
  isCharitable: boolean;
}

const ListingFacilitiesSection: React.FC<Props> = ({
  facilities,
  isCharitable,
}) => {
  const { T } = useIntl();

  return (
    <Grid
      id="facilities"
      container
      data-test-locator="Listing/ListingFacilitiesSection"
    >
      <Grid item xs={12}>
        {facilities.map(groupItem => {
          const groupName = Object.keys(groupItem)[0];
          const filteredFacilities = !isCharitable
            ? groupItem[groupName]
            : omit(groupItem[groupName], CharityListingFacilitiesToOmit);

          return (
            <ListingFacilitiesGroup
              groupName={T(FacilitiesGroupsTranslations[groupName])}
              facilities={filteredFacilities as ListingFacilities}
              key={groupName}
            />
          );
        })}
      </Grid>
    </Grid>
  );
};

export { ListingFacilitiesSection };
